// DSS Documentation on Angular - http://tiny.sc/cgangular
// DSS Documentation on Angular Reuse - http://tiny.sc/cgangularreuse
import { NgModule } from '@angular/core';

// DSS Documentation on SocoSearchPipe - http://tiny.sc/cgsocosearchpipe
import { SocoSearchPipe } from '@app/soco/common/soco-search.pipe';
// DSS Documentation on SocoSystemMessageComponent - http://tiny.sc/cgsocosystemmessagecomponent
import { SocoSystemMessageComponent } from '@app/soco/common/soco-system-message.component';

const SOCO_MODULE_DIRECTIVES = [
    // DSS Documentation on SocoSearchPipe - http://tiny.sc/cgsocosearchpipe
    SocoSearchPipe,
    // DSS Documentation on SocoSystemMessageComponent - http://tiny.sc/cgsocosystemmessagecomponent
    SocoSystemMessageComponent
];

@NgModule({
    exports: SOCO_MODULE_DIRECTIVES,
    declarations: SOCO_MODULE_DIRECTIVES
})
export class SocoCommonModule { }
